import "../style/base.scss";
import "../style/loader.scss";
import "../style/landing.scss";
import "../style/coollink.scss";
import "../style/skills.scss";
import "../style/reviews.scss"
import "../style/swiper.scss";
import "../style/projects.scss";
import "../style/faq.scss";
import "../style/contact.scss";
